import ActionGroup from '@/diagrams/models/action-group'
import {
  Component,
  Prop,
  Mixins,
  Vue,
  Ref,
  Watch,
} from 'vue-property-decorator'
import EditDialogMixin from '@/common/dialogs/mixins/edit-dialog-mixin'
import ActiongroupsService from '@/diagrams/services/actiongroups-service'

@Component
export default class ActionGroupDialog extends Mixins<
  EditDialogMixin<ActionGroup>
>(EditDialogMixin) {
  @Watch('dialog')
  private async dialogChanged(newValue: boolean) {
    if (newValue) {
      await this.validate()
    }
  }
}
